import { Input } from '@woodmac-hycb/form-input';
import { Col, Row, View } from '@woodmac-hycb/layout';
import { List, ListItem } from '@woodmac-hycb/list';
import { Text } from '@woodmac-hycb/text';
import React, { useCallback, useEffect, useState } from 'react';
import { getEntities } from '../services/EntityService';
import useDebounce from '../hooks/UseDebounce';
import './CustomAlertManager.css';
import { useToggleRegion } from '../hooks/useToggleRegion';
import { CheckButton, EnhancedRadioGroup } from '@woodmac-hycb/check-button';
import { AdvancedTable } from '@woodmac-hycb/advanced-table';
import { useAuth0 } from '@auth0/auth0-react';

function PlantList({ SetSelectedPlant }) {

    const [plants, setPlants] = useState([]);

    const [selectedPlant, setPlantSelected] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 800);

    const { isRegionNa, updateRegion } = useToggleRegion();
    const { getAccessTokenSilently } = useAuth0();

    const [activePlants, setActivePlants] = useState(true);

    const [offset, setOffset] = useState(0);
    const OFFSET_INTERVAL = 10;

    const handleSearchTerm = (event) => {
        setSearchTerm(event.target.value);
    };

    const setSelected = (id) => {
        const plant = plants.find((p) => (p.entityId === id))
        setPlantSelected(plant);
        SetSelectedPlant(plant);
    }

    const resetSelectedPlant = useCallback(() => {
        setPlantSelected(null);
        SetSelectedPlant(null);
    }, [setPlantSelected, SetSelectedPlant])

    const selectedId = selectedPlant ? selectedPlant.entityId : null;


    const getPlants = async () => {
        const token = await getAccessTokenSilently();
        const response = await getEntities(offset, searchTerm, isRegionNa ? "na" : "eu", activePlants, token)
        if (response.status === 200) {
            const newPlants = response.data;
            setPlants((oldPlants) => ([...oldPlants, ...newPlants]));
            setOffset(prevOffset => (prevOffset + OFFSET_INTERVAL))
        }
    };

    const handleScroll = async (e) => {
        const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
        if (bottom) {
            await getPlants();
        }
    }

    useEffect(() => {
        const getEnts = async () => {
            const token = await getAccessTokenSilently();
            const response = await getEntities(0, debouncedSearchTerm, isRegionNa ? "na" : "eu", activePlants, token);
            if (!response.status === 200) {
                setPlants([]);
            } else {
                const plants = response.data;
                setPlants(plants);
                setLoading(false);
                var scroller = document.getElementById('scrollbox');
                if (scroller) {
                    scroller.scrollTop = 0;
                }
                resetSelectedPlant();
                setOffset(OFFSET_INTERVAL)
            }
        };

        getEnts();
    }, [isRegionNa, activePlants, resetSelectedPlant, getAccessTokenSilently, debouncedSearchTerm])

    return (
        <Col gap={16} flex=".25">
            <Row gap={16} justifyContent='space-between' alignItems='center'>
                <Text fontSize='ty120'>Plants</Text>
                <EnhancedRadioGroup
                    value={activePlants ? "on" : "off"}
                    onChange={() => { setActivePlants(!activePlants) }}
                >
                    <CheckButton width="75px" value="on">
                        Active
                    </CheckButton>
                    <CheckButton width="75px" value="off">
                        Inactive
                    </CheckButton>
                </EnhancedRadioGroup>
            </Row>
            {isLoading ?
                <View height={350}>
                    <AdvancedTable loading
                        pagination={false} />
                </View>
                :
                <Col gap={8}>
                    <Row gap={16} justifyContent="space-between">
                        <Input
                            type='text'
                            placeholder='Plant Name'
                            value={searchTerm}
                            onChange={handleSearchTerm}
                        />
                        <EnhancedRadioGroup
                            value={isRegionNa ? "na" : "eu"}
                            onChange={() => { updateRegion(!isRegionNa) }}
                        >
                            <CheckButton width="75px" value="na">
                                NA
                            </CheckButton>
                            <CheckButton width="75px" value="eu">
                                EU
                            </CheckButton>
                        </EnhancedRadioGroup>
                    </Row>
                    <View className="plant-names-list" height={310} onScroll={handleScroll} id="scrollbox">
                        <List value={selectedId} onChange={setSelected}>
                            {plants.map((plant) => (
                                <ListItem
                                    key={plant.entityId}
                                    value={plant.entityId}>
                                    {plant.entityFullName}
                                </ListItem>
                            ))}
                        </List>
                    </View>
                </Col>
            }
        </Col >
    );
};

export default PlantList;